export function Dashboard() {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Dashboard</h2>
      <p className="text-admin-text-secondary">Velkommen til Amino Backoffice.</p>
    </div>
  );
}
